module.exports = __webpack_public_path__ + "img/paypal.7f2c798.svg";